// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__YaER7","label":"Labeled_label__2v9-j","divider":"Labeled_divider__2hdAg"};